import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { connectModal } from 'redux-modal';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import get from 'lodash/get';
import omit from 'lodash/omit';
import { SspApi } from '../../../api';
import { baseApiUrl } from '../../../api/ApiHelpers';
import { setLoader, removeLoader } from '../../../actions';
 
import {
  InputField,
  SelectField,
  FileField,
  required,
  url
} from '../../../components/form';

class FeedForm extends Component {

  onFormSubmit(vals) {
    const {
      dispatch,
      handleHide,
      formAction,
      feed,
      feeds,
      website
    } = this.props;

    const args = formAction === 'Update' ? [feed.uuid, website.uuid, vals] : [website.uuid, vals];
    
    dispatch(setLoader('FeedForm'));

    dispatch(SspApi.actions[`feed${formAction}`].post(...args, (error, success) => {
      dispatch(removeLoader('FeedForm'));
      if (success) {
        let collection = [...feeds.data];

        if (formAction === 'Update') {
          collection = [...feeds.data].map((obj) => {
            return obj.uuid === success.data.uuid ? success.data : obj;
          });
        } else if (formAction === 'Create') {
           collection.unshift(success.data);
        }

        dispatch({
          type: SspApi.events.feeds.actionSuccess,
          syncing: false,
          data: { ...feeds, data: collection, meta: { ...feeds.meta } }
        });

        handleHide();
      }
    }));
  }

  render() {
    const { 
      show, handleHide, handleSubmit, heading, formAction, isLoading, feedSources, website, token 
    } = this.props;

    return (
      <Modal show={show} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>

        <form
          onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
          className='m-t'
        >
          <Modal.Body>
            <Field
              type='text'
              name='feed[name]'
              placeholder='Name of your feed'
              label='Name'
              component={InputField}
              validate={[required]}
            />
            <Field
              type='text'
              name='feed[ssp_feed_source_id]'
              placeholder='Select a Feed Provider'
              label='Feed Provider'
              component={SelectField}
              options={feedSources.map((e) => {
                return { label: e.name, value: e.id };
              })}
              normalize={(e) => e.value}
              validate={[required]}
            />
            <Field
              type='text'
              name='feed[url]'
              placeholder='URL of your feed'
              label='Feed URL'
              component={InputField}
              validate={[required, url]}
            />
            <p className="text-center">or</p>
            <Field
              type='text'
              name='feed[url]'
              placeholder='URL of your feed'
              component={FileField}
              filetypes="application/gzip, text/xml, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              maxSize={104857600}
              gcs={{
                path: `/feeds/${website.slug}/`,
                bucket: 'ssp-feed',
                host: baseApiUrl,
                token
              }}
              normalize={(e) => e[0]}
              validate={[required, url]}
            />

            <Field
              type='text'
              name='feed[cron]'
              placeholder='Select index frequency'
              label='Index Frequency'
              component={SelectField}
              options={[
                { label: 'Every 3 Hours', value: '0 */3 * * *' },
                { label: 'Every 6 Hours', value: '0 */6 * * *' },
                { label: 'Every 12 Hours', value: '0 */12 * * *' },
                { label: 'Every 18 Hours', value: '0 */18 * * *' },
                { label: 'Every Day', value: '1 0 * * *' }
              ]}
              normalize={(e) => e.value}
              validate={[required]}
            />

          </Modal.Body>

          <Modal.Footer>
            <Button onClick={handleHide}>Close</Button>
            <Button
              type='submit'
              loading={isLoading}
              bsStyle='primary'
            >
              {formAction || 'Submit'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'FeedForm'
});

const ResourceModal = connectModal({
  name: 'FeedFormModal'
});

const mapStateToProps = (state) => {
  const { loader, modal: { FeedFormModal } } = state;
  const isLoading = loader.includes('FeedForm');
  const feed = get(FeedFormModal, 'props.feed', {});
  const feeds = get(state, 'ssp.feeds.data', {});
  const feedSources = get(state, 'ssp.feedSources.data.data', []);
  const token = get(state, 'auth.data.token', null);

  const initialValues = {
    feed: {
      name: feed.name,
      url: feed.url,
      ssp_feed_source_id: feed.ssp_feed_source_id,
      cron: feed.cron
    }
  };

  return { isLoading, initialValues, feeds, feedSources, token };
};

export default connect(mapStateToProps)(ResourceModal(ResourceForm(FeedForm)));
